// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { nextThursday as fn } from "../nextThursday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const nextThursday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default nextThursday;
